import { useState } from 'react';
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerFooter, DrawerClose } from '@/components/ui/drawer';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function DialogImportEmails({ open, onClose, onImport }) {
    const { t } = useTranslation();
    const [textInput, setTextInput] = useState('');

    const handleImport = () => {
        // Parse emails: split by newlines, commas and semicolons
        const emails = textInput
            .split(/[\n,;]+/)
            .map((email) => email.trim())
            .filter((email) => email.length > 0);

        onImport(emails);
        setTextInput('');
    };

    const handleClose = () => {
        setTextInput('');
        onClose();
    };

    return (
        <Drawer open={open} onOpenChange={handleClose}>
            <DrawerContent>
                <DrawerHeader className="relative">
                    <DrawerTitle className="text-center">{t('procedures:importerDesEmails')}</DrawerTitle>
                    <DrawerClose asChild>
                        <Button
                            variant="plain"
                            color="neutral"
                            size="auto"
                            className="absolute right-4 top-4"
                            onClick={handleClose}
                        >
                            <X className="w-5 h-5" />
                        </Button>
                    </DrawerClose>
                </DrawerHeader>

                <div className="px-4 pb-4 space-y-4">
                    <p className="text-sm text-muted-foreground">
                        {t('procedures:collezVotreListeDEmails')} <span className="text-warning">{t('procedures:unParLigne')}</span> {t('procedures:ouSeparesParDesVirgulesOuDesPoints')}
                    </p>

                    <textarea
                        value={textInput}
                        onChange={(e) => setTextInput(e.target.value)}
                        placeholder={`email1@example.com\nemail2@example.com\nemail3@example.com`}
                        rows={6}
                        className="w-full px-3 py-2 bg-surface border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary resize-none font-mono text-sm"
                    />
                </div>

                <DrawerFooter className="flex-row gap-3">
                    <Button type="button" variant="soft" color="neutral" onClick={handleClose} className="flex-1">
                        {t('procedures:annuler')}
                    </Button>
                    <Button
                        variant="soft"
                        color="secondary"
                        onClick={handleImport}
                        disabled={!textInput.trim()}
                        className="flex-1 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {t('procedures:importer')}
                    </Button>
                </DrawerFooter>
            </DrawerContent>
        </Drawer>
    );
}
